import React from "react";
import { Button } from "@/components/ui/button";
import { VOLUNTEER } from "@/constants/testIds";
import { Users, Building2 } from "lucide-react";

// Onboarding step 1: account-type chooser (extracted from Onboarding.jsx in
// the Phase 15 component split — behaviour unchanged).

const TYPE_OPTIONS = [
  { id: "individual", t: "I'm an individual", d: "Sign up to volunteer, log hours and earn badges.", icon: Users, tid: VOLUNTEER.onboardingIndividual },
  { id: "organisation", t: "I'm an organisation", d: "Post opportunities, approve hours and find skills.", icon: Building2, tid: VOLUNTEER.onboardingOrg },
];

export function TypeStep({ type, setType, onNext }) {
  return (
    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
      {TYPE_OPTIONS.map((o) => (
        <button
          key={o.id}
          data-testid={o.tid}
          onClick={() => setType(o.id)}
          className={`text-left bg-white border rounded-xl p-7 transition-all hover:-translate-y-1 hover:shadow-md ${type === o.id ? "border-forest ring-2 ring-forest/15" : "border-neutral-200"}`}
        >
          <o.icon className="w-7 h-7 text-terracotta" />
          <div className="font-display text-xl text-forest mt-4">{o.t}</div>
          <div className="text-sm text-neutral-600 mt-1.5">{o.d}</div>
        </button>
      ))}
      <div className="md:col-span-2 flex justify-end">
        <Button data-testid={VOLUNTEER.onboardingNext} onClick={onNext} className="rounded-full bg-forest hover:bg-forest-hover h-11 px-6">
          Continue
        </Button>
      </div>
    </div>
  );
}
